// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ExpandArrow from '../_raw/ui/icon_expand_arrow.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ExpandArrow);
